<template>
  <div class="wrapper" :style="wrapperStyle" @mouseover="onHover" @mouseleave="onLeave" @click="$emit('click')">
    <div class="box">
      <div class="color" :style="colorStyle">
        <div v-if="isCanChangeColor && color && isHovering" class="box-icon">
          <i class="icon icon-t-blog" />
        </div>
        <i v-else-if="isCanChangeColor && !color" class="icon icon-add" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
    },
    isCanChangeColor: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  data() {
    return {
      wrapperStyle: '',
      colorStyle: '',
      isHovering: false,
      activeColor: '#3C67FF',
      hoverColor: '#666666',
    };
  },
  watch: {
    color() {
      this.initStyle();
    },
    isActive(val) {
      if (!val) {
        this.wrapperStyle = [];
      }
    },
  },
  created() {
    this.initStyle();
  },
  methods: {
    initStyle() {
      this.colorStyle = this.color
        ? [{ background: this.color, border: `1px solid ${this.getBorderColor()}` }]
        : [{ border: `1px dashed ${this.hoverColor}` }];
      if (this.isActive) {
        this.wrapperStyle = [{ border: `1px solid ${this.activeColor}` }];
        this.colorStyle = [
          {
            background: this.color,
            border: `1px solid ${this.getBorderColor()}`,
          },
        ];
      }
    },
    onHover() {
      this.wrapperStyle = [
        {
          border: `1px solid ${this.hoverColor}`,
        },
      ];
      if (!this.color) {
        this.colorStyle = '';
      }
      this.isHovering = true;
    },
    onLeave() {
      this.wrapperStyle = this.isActive ? [{ border: `1px solid ${this.activeColor}` }] : [];
      this.isHovering = false;
      if (!this.color && !this.isActive) {
        this.colorStyle = [{ border: `1px dashed ${this.hoverColor}` }];
      }
    },
    getBorderColor() {
      return this.$tinycolor(this.color).isDark()
        ? this.$tinycolor.mix(this.color, 'white', 30).toHex8String()
        : this.$tinycolor.mix(this.color, 'black', 30).toHex8String();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.wrapper {
  width: 32px;
  height: 32px;
  padding: 1px;
  border: 1px solid #ffffff00;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;

  @media only screen and (max-width: 1300px) {
    margin: 3px;
  }

  .box {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    background-image: url('/editor/static/icons/bg-transparent.svg');
  }

  .color {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 3px;
    background: map-get($hybrid-shade-dark, '200');
  }

  .icon-t-blog {
    font-size: 16px;
  }

  .box-icon {
    background: #7e6f6f66;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
